function getCustomFieldZendeskId(fieldId, valueId = null) {
  const mapping = {
    'contactField5': {
      'zendeskId': '27677187914509',
    },
    'contactSubField6': {
      'zendeskId': '27677336068749'
    },
    'contactField7': {
      'zendeskId': '27677520871181',
      'valuesZendeskId': {
        'Un produit FACOM que je possède déjà': '27678657649037',
        'Un produit FACOM que je ne possède pas encore': '27678867333261',
        'Autre chose': '27679542381197',
      }
    },
    'contactSubFieldC': {
      'zendeskId': '360010591498'
    },
    'contactSubFieldD': {
      'zendeskId': '360010629277'
    },
    'contactSubFieldF': {
      'zendeskId': '360010629317'
    },
    'contactSubFieldA': {
      'zendeskId': '360010661997'
    },
    'contactSubFieldG': {
      'zendeskId': '27679812229901'
    },
    'contactSubFieldB': {
      'zendeskId': '360010662177'
    },
    'contactSubFieldK': {
      'zendeskId': '27680077108109'
    },
    'contactSubFieldH': {
      'valuesZendeskId': {
        'Un produit FACOM que je possède déjà': '27680198479885',
        'Un produit FACOM que je ne possède pas encore': '27682811490445',
        'Autre chose': '27682871285389',
      }
    },
    'contactSubFieldI': {
      'valuesZendeskId': {
        'Un produit FACOM que je possède déjà': '27680198479885',
        'Un produit FACOM que je ne possède pas encore': '27682811490445',
        'Autre chose': '27682871285389',
      }
    },
    'contactSubFieldJ': {
      'valuesZendeskId': {
        'Un produit FACOM que je possède déjà': '27680198479885',
        'Un produit FACOM que je ne possède pas encore': '27682811490445',
        'Autre chose': '27682871285389',
      }
    },
  };

  if (null === valueId) {
    return mapping[fieldId].zendeskId ?? null;
  }

  return mapping[fieldId].valuesZendeskId[valueId] ?? null;
}

function getValueWithSuffix(value, zendeskId) {
  const valueWithSuffix = {
    'des_informations_techniques': {
      '27678867333261': '_un_produit',
      'default': ''
    },
    'une_demande_de_documentation': {
      '27679542381197': '_autre_chose',
      '27678867333261': '_un_produit',
      'default': ''
    },
    'catalogue_produits': {
      '27682811490445': '_type',
      'default': ''
    },
    'une_reclamation__suggestion_ou_commentaire': {
      '27679542381197': '_autre_chose',
      'default': ''
    },
  }

  if (valueWithSuffix[value] !== undefined) {
    let suffix = valueWithSuffix[value][zendeskId] ?? null;
    if (null === suffix) {
      suffix = valueWithSuffix[value]['default'] ?? null;
    }
    if (null === suffix) {
      suffix = valueWithSuffix[value] ?? '';
    }
    return value + suffix;
  }

  return value;
}

function fieldValueToZendeskTag(value, zendeskId = null) {
  value = value.toLowerCase();
  value = value.replaceAll(' ', '_');
  value = value.replaceAll('\'', '_');
  value = value.replaceAll(',', '_');
  value = value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  return getValueWithSuffix(value, zendeskId);
}

function getMyRequestConcernsActiveField(iNeedHelpForContainer) {
  let activeField = iNeedHelpForContainer.nextElementSibling;
  while (activeField.style.display === 'none') {
    activeField = activeField.nextElementSibling;
  }

  return activeField;
}

function getDocumentTypeActiveField(myRequestConcernsContainer) {
  let activeField = myRequestConcernsContainer.nextElementSibling;
  while (activeField.style.display === 'none') {
    activeField = activeField.nextElementSibling;
  }

  return activeField;
}

function fieldAndContainerExistsAndIsDisplayed(field) {
  return field
    && field.parentElement
    && field.parentElement.style.display !== 'none'
    && field.parentElement.parentElement
    && field.parentElement.parentElement.style.display !== 'none'
    ;
}

let firstSubmit = true;
const contactForm = document.querySelector('.cc-contact-form form');
if (contactForm) {
  contactForm.addEventListener('submit', (e) => {
    e.preventDefault();
    e.stopImmediatePropagation();

    if (firstSubmit) {
      firstSubmit = false;

      const name = contactForm.querySelector('#name input');
      const email = contactForm.querySelector('#email input');
      const phone = contactForm.querySelector('#phone input');
      const iam = contactForm.querySelector('#contactField5 select');
      const userType = contactForm.querySelector('#contactSubField6 select');

      const iNeedHelpForContainer = contactForm.querySelector('#contactField7');
      let iNeedHelpFor = null;
      if (iNeedHelpForContainer) {
        iNeedHelpFor = iNeedHelpForContainer.querySelector('select');
      }

      const myRequestConcerns = getMyRequestConcernsActiveField(iNeedHelpForContainer).querySelector('select');

      let myRequestConcernsContainer = null;
      if (myRequestConcerns) {
        myRequestConcernsContainer = myRequestConcerns.parentElement.parentElement;
      }

      const address = contactForm.querySelector('#contactSubFieldC input');
      const city = contactForm.querySelector('#contactSubFieldD input');
      const zipcode = contactForm.querySelector('#contactSubFieldF input');
      const modelNumber = contactForm.querySelector('#contactSubFieldA input');
      const savNumber = contactForm.querySelector('#contactSubFieldG input');
      const serialNumber = contactForm.querySelector('#contactSubFieldB input');
      const damageType = contactForm.querySelector('#contactSubFieldK select');
      const documentType = getDocumentTypeActiveField(myRequestConcernsContainer).querySelector('select');
      const description = contactForm.querySelector('#description textarea');
      const attachment = contactForm.querySelector('#contactField12 input');

      const customFields = [];

      if (fieldAndContainerExistsAndIsDisplayed(iam)) {
        customFields.push({
          id: getCustomFieldZendeskId(iam.parentElement.parentElement.id),
          value: fieldValueToZendeskTag(iam.value),
        });
      }

      if (fieldAndContainerExistsAndIsDisplayed(userType)) {
        customFields.push({
          id: getCustomFieldZendeskId(userType.parentElement.parentElement.id),
          value: fieldValueToZendeskTag(userType.value),
        });
      }

      if (fieldAndContainerExistsAndIsDisplayed(iNeedHelpFor)) {
        customFields.push({
          id: getCustomFieldZendeskId(iNeedHelpFor.parentElement.parentElement.id),
          value: fieldValueToZendeskTag(iNeedHelpFor.value),
        });

        if (fieldAndContainerExistsAndIsDisplayed(myRequestConcerns)) {
          const myRequestConcernsZendeskId = getCustomFieldZendeskId(iNeedHelpFor.parentElement.parentElement.id, iNeedHelpFor.value);
          customFields.push({
            id: myRequestConcernsZendeskId,
            value: fieldValueToZendeskTag(myRequestConcerns.value, myRequestConcernsZendeskId),
          });
        }

        if (fieldAndContainerExistsAndIsDisplayed(documentType)) {
          const documentTypeZendeskId = getCustomFieldZendeskId(documentType.parentElement.parentElement.id, iNeedHelpFor.value);
          customFields.push({
            id: documentTypeZendeskId,
            value: fieldValueToZendeskTag(documentType.value, documentTypeZendeskId),
          });
        }
      }

      if (fieldAndContainerExistsAndIsDisplayed(address)) {
        customFields.push({
          id: getCustomFieldZendeskId(address.parentElement.id),
          value: address.value,
        });
      }

      if (fieldAndContainerExistsAndIsDisplayed(city)) {
        customFields.push({
          id: getCustomFieldZendeskId(city.parentElement.id),
          value: city.value,
        });
      }

      if (fieldAndContainerExistsAndIsDisplayed(zipcode)) {
        customFields.push({
          id: getCustomFieldZendeskId(zipcode.parentElement.id),
          value: zipcode.value,
        });
      }

      if (fieldAndContainerExistsAndIsDisplayed(modelNumber)) {
        customFields.push({
          id: getCustomFieldZendeskId(modelNumber.parentElement.id),
          value: modelNumber.value,
        });
      }

      if (fieldAndContainerExistsAndIsDisplayed(savNumber)) {
        customFields.push({
          id: getCustomFieldZendeskId(savNumber.parentElement.id),
          value: savNumber.value,
        });
      }

      if (fieldAndContainerExistsAndIsDisplayed(serialNumber)) {
        customFields.push({
          id: getCustomFieldZendeskId(serialNumber.parentElement.id),
          value: serialNumber.value,
        });
      }

      if (fieldAndContainerExistsAndIsDisplayed(damageType)) {
        customFields.push({
          id: getCustomFieldZendeskId(damageType.parentElement.parentElement.id),
          value: fieldValueToZendeskTag(damageType.value),
        });
      }

      const body = {
        'ticket': {
          brand_id: 360001945658,
          group_id: 360017160852,
          subject: 'Facom Webform Support Request',
          requester: {
            name: name.value,
            email: email.value,
            phone: phone.value,
          },
          comment: {
            body: description.value,
          },
          custom_fields: customFields,
          status: 'new',
          tags: [
            'facom_france_form'
          ]
        }
      };

      const formData = new FormData();
      formData.append('ticket', JSON.stringify(body));

      if (attachment.files[0]) {
        formData.append('file', attachment.files[0]);
      }

      const appUrl = document.querySelector('div.app-url-container').getAttribute('data-app-url');

      let token = '';
      if (appUrl.includes('dev')) {
        token = '41bda29d-bed0-450b-ba58-7bb8779ce3bb';
      } else if (appUrl.includes('stg')) {
        token = '34842dd4-a7f6-431d-92ac-a15ccbdbd537'
      } else {
        token = '1b07959a-6d3d-443a-9603-1967eefe7f07';
      }

      const myHeaders = new Headers();
      myHeaders.append('token', token);

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formData,
        redirect: 'follow'
      };

      fetch(appUrl, requestOptions)
          .then((response) => response.text())
          .then((result) => console.log(result))
          .catch((error) => console.error(error))
          .finally(() => window.location.replace(window.location.href + '?contact_posted=true'))
    }
  });
}
